export interface DataColumn {
  id: string;
  name: string;
}

// eslint-disable-next-line no-shadow
export enum ShouldShowModal {
  detail = 'detail',
}
